export function HeaderSeparator() {
  return <div className="mx-0.5 h-5 w-px shrink-0 bg-white/25" aria-hidden="true" />;
}
